import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './anonymous/login/login.component';
import { AnonymousComponent } from './anonymous/anonymous.component';
import { AuthorizedComponent } from './authorized/authorized.component';
import { OrganizationsListComponent } from './authorized/organizations-list/organizations-list.component';
import { OrganizationComponent } from './authorized/organization/organization.component';
import { Auth } from './shared/core/auth';
import { AdminSoundsComponent } from './authorized/admin-sounds/admin-sounds.component';
import { StatusSoundsComponent } from './authorized/status-sounds/status-sounds.component';
import { EndTimeComponent } from './authorized/end-time/end-time.component';
import { TimeRuleComponent } from './authorized/time-rule/time-rule.component';
import { OrganizationStatusComponent } from './authorized/organization-status/organization-status.component';
import { StatusComponent } from './authorized/status/status.component';

const appRoutes: Routes = [
  { path: '', redirectTo: 'list', pathMatch: 'full', canActivate: [Auth] },
  {
    path: 'login',
    component: AnonymousComponent,
    children: [{ path: '', component: LoginComponent }]
  },
  {
    path: 'list',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: '', component: OrganizationsListComponent }]
  },
  {
    path: 'adminsound',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: '', component: AdminSoundsComponent }]
  },
  {
    path: 'statsound',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: '', component: StatusSoundsComponent }]
  },
  {
    path: 'endtime',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: '', component: EndTimeComponent }]
  },
  {
    path: 'timerule',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: '', component: TimeRuleComponent }]
  },
  {
    path: 'orgedit',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: ':orgId', component: OrganizationComponent }]
  },
  {
    path: 'orgstatus',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: ':orgId', component: OrganizationStatusComponent }]
  },
  {
    path: 'statedit',
    component: AuthorizedComponent,
    canActivate: [Auth],
    children: [{ path: ':statusId', component: StatusComponent }]
  }
  // statedit
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true })],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// E:/proj/news12/zb-n12/scadmin/client/src/app/app-routing.module.ts